(() => {
  const DESKTOP_MIN = 980;
  const INTERVAL = 1000;
  const MAX_FRAMES = 4; // ✅ 1,2,3,4

  // ✅ NEW: only run hover behavior on real hover devices (mouse/trackpad)
  const canHover = () =>
    window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function bind() {
    document.querySelectorAll('.prod-image .reveal').forEach(reveal => {
      const card = reveal.closest('.prod-image');
      if (!card || card.dataset.hoverLoopBound === '1') return;
      card.dataset.hoverLoopBound = '1';

      const firstFrame = reveal.querySelector(':scope > .box-ratio');
      let hiddenFrames = Array.from(reveal.querySelectorAll(':scope > .hidden'));

      if (!firstFrame || hiddenFrames.length < 1) return;

      // ✅ Solo usamos 3 hidden como máximo (para total 4 frames)
      hiddenFrames = hiddenFrames.slice(0, MAX_FRAMES - 1);

      reveal.style.position = 'relative';

      firstFrame.style.position = 'relative';
      firstFrame.style.zIndex = '1';
      firstFrame.style.transition = 'opacity 200ms ease';
      firstFrame.style.opacity = '1';

      hiddenFrames.forEach((h) => {
        h.style.display = 'block';
        h.style.position = 'absolute';
        h.style.inset = '0';
        h.style.zIndex = '2';
        h.style.transition = 'opacity 200ms ease';
        h.style.opacity = '0';
        h.style.visibility = 'hidden';
        h.style.pointerEvents = 'none';

        const box = h.querySelector('.box-ratio');
        if (box) {
          box.style.position = 'absolute';
          box.style.inset = '0';
          box.style.height = '100%';
          box.style.paddingBottom = '0';
        }
      });

      const framesCount = 1 + hiddenFrames.length; // <= 4

      function show(idx) {
        firstFrame.style.opacity = idx === 0 ? '1' : '0';

        hiddenFrames.forEach((h, i) => {
          const on = (idx === i + 1);
          h.style.opacity = on ? '1' : '0';
          h.style.visibility = on ? 'visible' : 'hidden';
        });
      }

      let timer = null;
      let idx = 0;

      card.addEventListener('mouseenter', () => {
        // ✅ NEW: prevent running on touch devices
        if (!canHover()) return;
        if (window.innerWidth < DESKTOP_MIN) return;

        // ✅ Al entrar: muestra la 2da inmediatamente
        idx = 1;
        show(idx);

        timer = setInterval(() => {
          // ✅ Secuencia: 2 -> 3 -> 4 -> 1 -> 2 -> ...
          idx = (idx === framesCount - 1) ? 0 : (idx + 1);
          show(idx);
        }, INTERVAL);
      });

      card.addEventListener('mouseleave', () => {
        // ✅ NEW: prevent reset on touch devices
        if (!canHover()) return;

        if (timer) clearInterval(timer);
        timer = null;
        idx = 0;
        show(0); // vuelve a la primera
      });
    });
  }

document.addEventListener('shopify:section:load', bind);

// ✅ Robust re-bind for AJAX sections (recommendations, recently viewed, etc.)
const observeAndRebind = () => {
  let t = null;

  const scheduleBind = () => {
    if (t) return;
    t = setTimeout(() => {
      t = null;
      bind();
    }, 150); // throttle para no spamear
  };

  // Observa toda la página: cuando Shopify inyecta recomendaciones, esto lo detecta
  const obs = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (m.addedNodes && m.addedNodes.length) {
        // Solo si aparece algo que podría ser un producto
        scheduleBind();
        break;
      }
    }
  });

  obs.observe(document.body, { childList: true, subtree: true });
};

document.addEventListener('DOMContentLoaded', () => {
  bind();
  observeAndRebind();

  // Extra: 2 reintentos rápidos por si Shopify inyecta justo después
  setTimeout(bind, 500);
  setTimeout(bind, 1500);
});
})();